module.exports = __webpack_public_path__ + "static/media/check-white.7002a8c5.svg";